import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Container, Row, Col } from 'react-bootstrap';
import { Activity, ClipboardCheck, Clock, Database, FileDown, FileText, HardDriveDownload, HardDriveUpload, Hourglass, Library, Globe } from 'lucide-react';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { BreadcrumbComponent } from '../../Components/BreadCrumb';
import './SuperadminMenuPage.css';

interface AdminFunction {
    title: string;
    description: string;
    icon: React.ComponentType<{ size?: number; className?: string }>;
    path: string;
}

const SuperadminMenuPage: React.FC = () => {
    useDocumentTitle('Superadmin-funktioner');

    const functions: AdminFunction[] = [
        {
            title: 'Instansinställningar',
            description: 'Konfigurera webb-URL och andra instansspecifika inställningar.',
            icon: Globe,
            path: '/superadmin/instance-settings',
        },
        {
            title: 'Underhållsbibliotek',
            description: 'Hantera centrala mallar för underhållsaktiviteter.',
            icon: Library,
            path: '/superadmin/maintenance-library',
        },
        {
            title: 'Livslängdsbibliotek',
            description: 'Hantera centrala mallar för livslängd och ersättningskostnad.',
            icon: Hourglass,
            path: '/superadmin/lifetime-library',
        },
        {
            title: 'Kontrollbibliotek',
            description: 'Hantera centrala mallar för kontroller.',
            icon: ClipboardCheck,
            path: '/superadmin/inspection-library',
        },
        {
            title: 'Exportera konfiguration',
            description: 'Exportera instansens konfiguration till fil för att sätta upp en ny instans.',
            icon: FileDown,
            path: '/superadmin/config-export',
        },
        {
            title: 'Exportera byggnad',
            description: 'Exportera en byggnad med komponenter, skick, foton och dokument till fil.',
            icon: HardDriveDownload,
            path: '/superadmin/building-export',
        },
        {
            title: 'Importera byggnad',
            description: 'Importera en byggnadsexport från en annan instans till denna instans.',
            icon: HardDriveUpload,
            path: '/superadmin/building-import',
        },
        {
            title: 'Inventeringstider',
            description: 'Se hur lång tid som spenderas i inventeringsfunktionen per byggnad.',
            icon: Clock,
            path: '/superadmin/inventory-times',
        },
        {
            title: 'Användaraktivitet',
            description: 'Se vem som har använt appen, när och vad de gjorde.',
            icon: Activity,
            path: '/superadmin/activity',
        },
        {
            title: 'Ändringslogg',
            description: 'Visa historik över komponentändringar och inventering.',
            icon: FileText,
            path: '/archive',
        },
        {
            title: 'Datamigrering',
            description: 'Kör tillfälliga datamigreringar. Inga aktiva migreringar just nu.',
            icon: Database,
            path: '/superadmin/data-migrations',
        },
    ];

    return (
        <>
        <BreadcrumbComponent items={[{ text: 'Superadmin-funktioner' }]} />
        <Container className="superadmin-menu-page">
            <h1 className="page-title">Superadmin-funktioner</h1>
            <Row>
                {functions.map((func) => (
                    <Col key={func.path} xs={12} md={6} lg={4} className="mb-4">
                        <Card
                            className="function-card"
                            as={Link}
                            to={func.path}
                        >
                            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                                <func.icon size={40} className="mb-3 function-icon" />
                                <Card.Title className="function-title">{func.title}</Card.Title>
                                <Card.Text className="function-description">
                                    {func.description}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
        </>
    );
};

export default SuperadminMenuPage;
